export default "/Frontend/dist/fallback.f2ad2ccb5daadbfa5d3ba3e704834a2a.svg";